import * as ATCCmd from "../../../js/myATCCommand.js";
import * as ATC from "../ATClient.js";

/**
 * ----------- boxInfo 数据格式 ---------------
 * {
 * 	ext:'本机号码',
 * 	uid:'坐席号码',
 * 	uidName:'坐席姓名',
 * 	phone:'对方电话号码',
 * 	name:'对方姓名',
 * 	status:'振铃、响铃、通话、通话保持、挂断',
 * 	time:'通话时间',
 * 	callId:'呼叫中心电话id',
 * 	logId:'本地记录的通话记录id',
 * 	customerType:'用户类型 1 陌生人 2 用户 3 服务员',
 * 	type:'业务类型 1 咨询 2需求 3 投诉 4合同 0未知',
 * 	callType:'通话类型 1:外线呼入，2:外线呼出，3:内线呼入，4.内线呼出，0.未知',
 *  winHref:'来电弹窗地址',
 * }
 */

// var ATCInfoBox = {}
var twkTimer = {};
var phoneTimer = {};
var extList = [];
var loginUid;
var loginExt;

function ring(info,clickInfoEvent,pickupBtnEvent,hangupBtnEvent,tranBtnEvent){//来电、响铃
	if(!info.phone){
		alert("缺失电话号码，通话功能异常！");
		return false;
	}
	createFrame();
	var boxId = createBox(clickInfoEvent,pickupBtnEvent,hangupBtnEvent,tranBtnEvent);
	info.status = '响铃';
	setBoxInfo(info,boxId);
	callBtnStatus(boxId, "show", "show", "hide");
	return boxId;
}

function pickup(boxId){//接听（通话）
	var boxObj = $("#"+boxId);
	boxObj.css("background-image","linear-gradient(to bottom right, #2c77ff, #a7c6ff)");
	boxObj.find(".callInfo").css("background-image","linear-gradient(to bottom right, #91d6ff, #0085f7)");
	var info = {};
	info.status = "通话中";
	setBoxInfo(info, boxId);
	callBtnStatus(boxId, "hide", "show", "show");
	
	if(!phoneTimer[boxId]){//非首次通话状态只改信息
		twinkleOut(boxId);
		//通话计时
		phoneTimer[boxId] = {};
		phoneTimer[boxId].h=0,phoneTimer[boxId].m=0,phoneTimer[boxId].s=1;
		phoneTimer[boxId].timer = setInterval(()=>{
			boxObj.find(".time").html(callTime(boxId));
		}, 1000);
		boxObj.find(".time").html("00:00:00");
	}
}

function holdon(boxId){//呼叫保持
	var boxObj = $("#"+boxId);
	boxObj.css("background-image","linear-gradient(to right bottom, rgb(95 62 6), rgb(236 175 64))");
	var info = {};
	info.status = "呼叫保持";
	setBoxInfo(info, boxId);
}

function retrive(boxId){//取回呼叫
	var boxObj = $("#"+boxId);
	boxObj.css("background-image","linear-gradient(to bottom right, #2c77ff, #a7c6ff)");
	boxObj.find(".callInfo").css("background-image","linear-gradient(to bottom right, #91d6ff, #0085f7)");
	var info = {};
	info.status = "通话中";
	setBoxInfo(info, boxId);
}

function hangup(boxId){//挂断、结束通话
	phoneTimer[boxId]&&setInterval(phoneTimer[boxId].timer);
	twinkleOut(boxId);
	twkTimer[boxId] = null;
	phoneTimer[boxId] = null;

	var boxObj = $("#"+boxId);
	boxObj.remove();
}

function tran(boxId){
	$("#myTranContent").toggle();
	if ($("#myTranContent").is(":visible")) {
		getTranStatusInfo();
	}
}

function getBoxInfo(boxId){
	var boxInfoObj = $("#"+boxId).find(".callInfoHide");
	if(!boxInfoObj.length){
		boxInfoObj = $("#"+boxId, window.parent.document).find(".callInfoHide");
	}
	var infoStr = boxInfoObj.text() && boxInfoObj.text().trim();
	return infoStr?JSON.parse(infoStr):{};
}

function getBoxInfoAll(){
	var boxInfoObjs = $("div[id^=ATCInfoBox_]").find(".callInfoHide");
	if(!boxInfoObjs.length){
		boxInfoObjs = $("div[id^=ATCInfoBox_]", window.parent.document).find(".callInfoHide");
	}
	var res = [];
	boxInfoObjs.each((idx, obj)=>{
		var boxInfoObj = $(obj);
		var infoStr = boxInfoObj.text() && boxInfoObj.text().trim();
		res.push(infoStr?JSON.parse(infoStr):{});
	});
	return res;
}

function createFrame() {
	if ($(".ATCInfoBoxFrame")&&$(".ATCInfoBoxFrame").length>0) {
		return false;
	}
	var frameHtml = "";
	frameHtml += "<div class='ATCInfoBoxFrame'>";

	frameHtml += "</div>";
	$(document.body).append(frameHtml);
	createTranTable();
}

function createTranTable(){
	var data = extList;
	var tableHtml = "";
	tableHtml += `
		<div id="myTranContent" class="tab-content">
            <div class="container-fluid">
				<div class="page-header">坐席列表<i class='fa fa-times closeTran' aria-hidden='true'></i></div>
                <div class="row">
                    <div class="col-md-12" style="height: 75vh;overflow: auto;">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>序号</th>
                                    <th>分机</th>
                                    <th>姓名</th>
                                    <th>服务项目</th>
                                    <th>坐席状态</th>
                                    <th>分机状态</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>`;
							if(data.length==0){
								tableHtml += `
							        <tr>
							            <td colspan="7" style="text-align:center;color:#999;">暂无数据</td>
							        </tr>`;
							}else{
								tableHtml += `
								<tr class="ext_auto">
									<td>1</td>
									<td colspan="2" class="loginExt">
										<input type="text" class="form-control" placeholder="请输入转接电话" 
										 name="outExt" id="outExt" style="width:150px"></input>
									</td>
									<td colspan="3" style="line-height:34px">转接外部电话，本地拨“9”，外地拨“90”</td>
									<td>
										<div class="tranBtn" style="display:flex">
											<a class="tranOneStep" style="display:block">&nbsp;直接转接 |</a>
											<a class="tranStart" style="display:block">&nbsp;协商转接 |</a>
											<a class="tranSuccess" style="display:block">&nbsp;协商完成 |</a>
											<a class="tranRetrive" style="display:block">&nbsp;协商取回 |</a>
											<!--<a class="tranOver" style="display:block">&nbsp;挂断 |</a>-->
										<div>
									</td>
								`;
								for(var idx in data){
									var tranEle = data[idx];
									// if(tranEle.loginExt==myATC.loginExt){
									// 	continue;
									// }
									tableHtml += `
										<tr class="ext_${tranEle.loginExt || ''}">
											<td>${idx-1+3}</td>
											<td class="loginExt" data-ext="${tranEle.loginExt || ''}" data-uid="${tranEle.loginUid || ''}">${tranEle.loginExt || ''}</td>
											<td>${tranEle.name || ''}</td>
											<td>${tranEle.serviceItem || ''}</td>
											<td class="uidStatus">${tranEle.uidStatus || ''}</td>
											<td class="extStatus">${tranEle.extStatus || ''}</td>
											<td>
												<div class="tranBtn" style="display:flex">
													<a class="tranOneStep" style="display:block">&nbsp;直接转接 |</a>
													<a class="tranStart" style="display:block">&nbsp;协商转接 |</a>
													<a class="tranSuccess" style="display:block">&nbsp;协商完成 |</a>
													<a class="tranRetrive" style="display:block">&nbsp;协商取回 |</a>
													<!--<a class="tranOver" style="display:block">&nbsp;挂断 |</a>-->
												<div>
											</td>
										`;
										tableHtml += `</tr>`;
								}
							}
							tableHtml +=`
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		`;
	$(".ATCInfoBoxFrame").after(tableHtml);
	setTimeout(() => {
		$(".closeTran").click((e)=>{
			$("#myTranContent").toggle();
		});
		$("#myTranContent").find(".tranOneStep").click((event)=>{tranOneStep(event);});
		$("#myTranContent").find(".tranStart").click((event)=>{consTran(event);});
		$("#myTranContent").find(".tranSuccess").click((event)=>{tranSuccess(event);});
		$("#myTranContent").find(".tranRetrive").click((event)=>{tranRetrive(event);});
		$("#myTranContent").find(".tranOver").click((event)=>{tranOver(event);});
	}, 0);
}

function getTranStatusInfo(){
	const _this = this;
	var callList = $("#myTranContent").find(".loginExt").toArray();
	for(var idx in callList){
		var ext = callList[idx].dataset.ext||'';
		var uid = callList[idx].dataset.uid||'';
		if(!ext || !uid){
			continue;
		}
		var uidInfo = ATC.ATGetUidInfo(uid);
		var m_status = uid_status(uidInfo.m_status||'');
		var m_call_status = ext_status(uidInfo.m_call_status||'');
		var m_name = uidInfo.m_name;

		var uidObj = $("#myTranContent").find(".ext_"+ext);
		uidObj.find(".uidStatus").html(m_status);
		uidObj.find(".extStatus").html(m_call_status);
	}
}

function tranOneStep(event){
	var phone = $(event.target).parent().parent().parent().find(".loginExt").find("#outExt").val()
	|| $(event.target).parent().parent().parent().find(".loginExt").text();
	phone = phone.replace(/[\n|\r|\t|\s]/g,'');
	if(!phone){
		util.error("转接分机号无效！");
		return;
	}
	ATCCmd.AT_Command(loginUid, loginExt, "TransCall",phone);
}

function consTran(event){
	var phone = $(event.target).parent().parent().parent().find(".loginExt").find("#outExt").val()
	|| $(event.target).parent().parent().parent().find(".loginExt").text();
	phone = phone.replace(/[\n|\r|\t|\s]/g,'');
	if(!phone){
		util.error("转接分机号无效！");
		return;
	}
	ATCCmd.AT_Command(loginUid, loginExt, "ConsTrans",phone);
}

function tranSuccess(event){
	ATCCmd.AT_Command(loginUid, loginExt, "TranOver");
}

function tranRetrive(event){
	ATCCmd.AT_Command(loginUid, loginExt, "RetriveCall");
}

function tranOver(event){
	var phone = $(event.target).parent().parent().parent().find(".loginExt").find("#outExt").val()
		|| $(event.target).parent().parent().parent().find(".loginExt").text();
	phone = phone.replace(/[\n|\r|\t|\s]/g,'');
	if(!phone){
		util.error("转接分机号无效！");
		return;
	}
	ATCCmd.AT_Command(loginUid, loginExt, "DisConnect",phone);
}

function changeTranExtStatus(EventCode, EventData, EventInfo){//实时刷新分级状态
	if(EventCode=="4"){
		$("#myTranContent .ext_"+EventData+" .extStatus").html(ext_status(EventInfo));
	}
}

function ext_status(EventInfo){
	var lbl_name;
	switch(EventInfo){
	case "01": // 空闲
		lbl_name = "空闲";break;
	case "02": // 应答
		lbl_name = "摘机";break;
	case "03": // 振铃
		lbl_name = "振铃";break;
	case "04": // 回铃
		lbl_name = "回铃";break;
	case "05": // 连接
		lbl_name = "通话";break;
	case "06": // 断开
		lbl_name = "断开";break;
	case "07": // 摘机
		lbl_name = "占用";break;
	case "08": // 转移
		lbl_name = "转移";break;
	default: // 未知
		lbl_name = "未知";break;
	}
	return lbl_name;
}

function uid_status(UidStatus) {
	var UidStatusStr = "";
	if (UidStatus == "01") UidStatusStr = "空闲";
	else if (UidStatus == "02") UidStatusStr = "忙碌";
	else if (UidStatus == "03") UidStatusStr = "事后处理";
	else if (UidStatus == "04") UidStatusStr = "离席";
	else if (UidStatus == "05") UidStatusStr = "选中";
	else if (UidStatus == "06") UidStatusStr = "未准备好";
	else if (UidStatus == "00") UidStatusStr = "注销";
	else UidStatusStr = "未知";

	return UidStatusStr;
}

function createBox(clickInfoEvent,pickupBtnEvent,hangupBtnEvent,tranBtnEvent) {
	var callId = uuid();
	var boxId = "ATCInfoBox_" + callId;
	if($("#"+boxId)&&$("#"+boxId).length>0){
		return boxId;
	}
	var boxHtml = "";
	boxHtml += "<div id='" + boxId + "' class='ATCInfoBox ringBox'>";
	boxHtml += "	<div class='callBtn'>";
	boxHtml += "		<i class='fa fa-phone pickup' title='接听' aria-hidden='true'></i>";
	boxHtml += "		<i class='fa fa-reply tran' title='转接' aria-hidden='true'></i>";
	boxHtml += "		<i class='fa fa-phone hangup' title='挂断' aria-hidden='true'></i>";
	boxHtml += "	</div>";
	boxHtml += "	<div class='callInfo' title='查看详情'>";
	boxHtml += "	</div>";
	boxHtml += "	<div class='callInfoHide' style='display:none'>";
	boxHtml += "	</div>";
	// boxHtml += "	<i class='fa fa-times close' aria-hidden='true'></i>";
	boxHtml += "	<i class='fa fa-dot-circle-o logo' title='窗口大小' aria-hidden='true'></i>";
	boxHtml += "</div>";
	$(".ATCInfoBoxFrame").append(boxHtml);
	boxZoom(boxId);
	setEvent(boxId,clickInfoEvent,pickupBtnEvent,hangupBtnEvent,tranBtnEvent);
	twinkle(boxId, 1000, 200);
	return boxId;
}

function setBoxInfo(info, boxId){
	//展示信息
	var boxInfoObj = $("#"+boxId).find(".callInfo");
	if(!boxInfoObj.length){
		boxInfoObj = $("#"+boxId, window.parent.document).find(".callInfo");
	}
	var userName = "";
	if (info.phone && (info.phone.length == 3)) {
		userName = "<sup>" + "E" + "</sup>" + "分机";
	}else if(info.customerType=="1"){//陌生人
		userName = "<sup>"+"?"+"</sup>"+(info.name||"加载中");
	}else if(info.customerType=="2"){//服务员
		userName = "<sup>"+"S"+"</sup>"+(info.name||"加载中");
	}else if(info.customerType=="3"){//用户
		userName = "<sup>"+"C"+"</sup>"+(info.name||"加载中");
	}else{
		userName = "<sup>"+"?"+"</sup>"+(info.name||"加载中");
	}
	if(!(boxInfoObj.html() && boxInfoObj.html().trim())){
		var infoHtml = "";
		infoHtml += "<div class='name'>"+(userName)+"</div>";
		infoHtml += "<div class='phone'>"+(info.phone||"")+"</div>";
		infoHtml += "<div class='status'>"+(info.status||"")+"</div>";
		infoHtml += "<div class='time'>"+(info.time||"")+"</div>";
		boxInfoObj.html(infoHtml);
	}else{
		info.name && boxInfoObj.find(".name").html(userName||"<sup>?</sup>加载中");
		info.phone && boxInfoObj.find(".phone").html(info.phone||"");
		info.status && boxInfoObj.find(".status").html(info.status||"");
		info.time && boxInfoObj.find(".time").html(info.time||"");
	}

	//非展示信息
	var boxInfoObj = $("#"+boxId).find(".callInfoHide");
	if(!boxInfoObj.length){
		boxInfoObj = $("#"+boxId, window.parent.document).find(".callInfoHide");
	}
	var hideInfo = boxInfoObj.text()?boxInfoObj.text().trim():'';
	var hideInfoObj = hideInfo?JSON.parse(hideInfo):{};
	if(info){
		if(typeof info == 'string'){
			info.trim() && $.extend(hideInfoObj,JSON.parse(info));
		}else if(typeof info == 'object'){
			$.extend(hideInfoObj,info);
		}
		boxInfoObj.text(JSON.stringify(hideInfoObj));
	}
}

function setEvent(boxId, clickInfoEvent, pickupBtnEvent, hangupBtnEvent, tranBtnEvent){
	clickEvet(boxId, clickInfoEvent);
	pickupEvt(boxId, pickupBtnEvent);
	hangupEvt(boxId, hangupBtnEvent);
	tranEvt(boxId, tranBtnEvent);
}

function clickEvet(boxId, clickInfoEvent){
	$("#" + boxId).find(".callInfo").click((e)=>{
		e.preventDefault();
		e.stopPropagation();
		clickInfoEvent&&clickInfoEvent(boxId);
	});
}

function pickupEvt(boxId, pickupBtnEvent){
	var boxObj = $("#" + boxId);
	boxObj.find(".pickup").click((e)=>{
		e.preventDefault();
		e.stopPropagation();
		var res = pickupBtnEvent && pickupBtnEvent(boxId);
		res && pickup(boxId);
	});

}

function hangupEvt(boxId, hangupBtnEvent){
	var boxObj = $("#" + boxId);
	boxObj.find(".hangup").click((e)=>{
		e.preventDefault();
		e.stopPropagation();
		var res = hangupBtnEvent && hangupBtnEvent(boxId);
		res && hangup(boxId);
	});
}

function tranEvt(boxId, tranBtnEvent){
	var boxObj = $("#" + boxId);
	boxObj.find(".tran").click((e)=>{
		e.preventDefault();
		e.stopPropagation();
		var res = tranBtnEvent && tranBtnEvent(boxId);
		res && tran(boxId);
	});
}

function boxZoom(boxId){
	var boxObj = $("#" + boxId);
	boxObj.find(".logo").click((e)=>{
		e.preventDefault();
		e.stopPropagation();
		boxObj.find("div").not(".callInfoHide").toggle();
		if(boxObj.find("div").not(".callInfoHide").is(':hidden')){
			boxObj.css("width","30px");
			boxObj.css("height","30px");
			boxObj.find(".fa.fa-dot-circle-o.logo").attr("class", "fa fa-phone logo");
		}else{
			boxObj.css("width","166px");
			boxObj.css("height","110px");
			boxObj.find(".fa.fa-phone.logo").attr("class", "fa fa-dot-circle-o logo");
		}
	});
}

function callBtnStatus(boxId, pickup, hangup, tran){
	var boxBtnObj = $("#"+boxId).find(".callBtn");
	pickup=="hide" ? boxBtnObj.find(".pickup").hide() : boxBtnObj.find(".pickup").show();
	hangup=="hide" ? boxBtnObj.find(".hangup").hide() : boxBtnObj.find(".hangup").show();
	tran=="hide" ? boxBtnObj.find(".tran").hide() : boxBtnObj.find(".tran").show();
}

function twinkle(boxId, fadeOut, fadeIn) {
	twkTimer[boxId] = setInterval(()=>{
		$("#" + boxId +".ringBox").fadeOut(fadeOut).fadeIn(fadeIn);
	}, 3000);
}

function twinkleOut(boxId){
	clearInterval(twkTimer[boxId]);
}

function callTime(boxId) {
	if(!phoneTimer[boxId]){
		return "";
	}
	var h = phoneTimer[boxId].h;
	var m = phoneTimer[boxId].m;
	var s = phoneTimer[boxId].s;
	
    if (s > 0 && (s % 60) == 0) {
        m += 1;
        s = 0;
    }
    if (m > 0 && (m % 60) == 0) {
        h += 1;
        m = 0;
    }
    var s10 = function () {
        if (s < 10) {
            var tmpS = "0" + s;
            return tmpS;
        } else {
            return s;
        }
    }
    var m10 = function () {
        if (m < 10) {
            var tmpM = "0" + m;
            return tmpM;
        } else {
            return m;
        }
    }
    var h10 = function () {
        if (h < 10) {
            var tmpH = "0" + h;
            return tmpH;
        } else {
            return h;
        }
    }
    var t = h10() + ":" + m10() + ":" + s10();
    s += 1;
    phoneTimer[boxId].h = h;
	phoneTimer[boxId].m = m;
	phoneTimer[boxId].s = s;
    return t;
}

function uuid() {
    function S4() {
       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

function setExtList(val){
	extList = val;
}

function setLoginUid(val){
	loginUid = val; 
}

function setLoginExt(val){
	loginExt = val; 
}


export {getBoxInfo,setBoxInfo,ring,setExtList,
	changeTranExtStatus,pickup,getBoxInfoAll,
	setLoginUid,setLoginExt}
